var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-input',{attrs:{"placeholder":"请输入身份证号"},on:{"input":_vm.sendIdcard},model:{value:(_vm.idcard),callback:function ($$v) {_vm.idcard=$$v},expression:"idcard"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }